import { render } from "./editcontent.vue?vue&type=template&id=3c1fdc9b"
import script from "./editcontent.vue?vue&type=script&lang=js"
export * from "./editcontent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__